import StaticHarvest from "./StaticHarvest"

export default StaticHarvest